function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/** Class containing orchestration logic and event handlers for the change location popup. */
class ChangeLocationPopup {
  /** Retrieves DOM elements for the change location popup and handles open and close logic. */
  constructor() {
    /* change location popup element */
    _defineProperty(this, "el", void 0);
    /* change location button element */
    _defineProperty(this, "changeLocationButton", void 0);
    /* change location popup close button element */
    _defineProperty(this, "closeButton", void 0);
    this.el = document.querySelector('[data-change-location-popup]');
    if (this.el) {
      this.addChangeLocationEventListener();
      this.addCloseButtonEventListener();
    }
  }

  /**
   * Retrieves change location button DOM element, sets DOM element to class property, and adds functionality to
   * open popup on click event.
   */
  addChangeLocationEventListener() {
    this.changeLocationButton = document.getElementById('change-location-popup-button');
    this.changeLocationButton.addEventListener('click', this.openChangeLocationPopup.bind(this));
  }

  /**
   * Retrieves change location popup close button DOM element, sets DOM element to class property, and adds
   * functionality to close popup on click event.
   */
  addCloseButtonEventListener() {
    this.closeButton = this.el.querySelector('.close-button');
    this.closeButton.addEventListener('click', this.closeChangeLocationPopup.bind(this));
  }

  /** Displays the change location popup using jQuery and Foundation. */
  openChangeLocationPopup() {
    $('#change-location-popup').foundation('open');
  }

  /** Hides the change location popup using jQuery and Foundation. */
  closeChangeLocationPopup() {
    $('#change-location-popup').foundation('close');
  }
}
const init = () => {
  new ChangeLocationPopup();
};
export { init };